export const CELLMULTISELECT_TEST_ID = 'cellmultiselect';
export const CELLSELECT_TEST_ID = 'cellselect';

export const LOGIN_CONTAINER_ID = 'login';
export const LOGIN_PASSWORD_ERROR = 'invalid-password-error';
export const RESET_WALLET_ID = 'reset-wallet-button';
export const CONFIRM_CHANGE_PASSWORD_INPUT_BOX_ID =
  'private-credential-password-input-field';
export const BROWSER_URL_MODAL_ID = 'browser-url-modal';
export const CLEAR_COOKIES_SECTION = 'clear-cookies-section';

// Design System test ids
export const FAVICON_AVATAR_IMAGE_ID = 'favicon-avatar-image';
export const NETWORK_AVATAR_IMAGE_ID = 'network-avatar-image';
export const CHECKBOX_ICON_ID = 'checkbox-icon';
export const SELECTABLE_LIST_ITEM_OVERLAY_ID = 'selectable-list-item-overlay';
export const CONFIRMATION_MODAL_NORMAL_BUTTON_ID =
  'confirmation-modal-normal-button';
export const CONFIRMATION_MODAL_DANGER_BUTTON_ID =
  'confirmation-modal-danger-button';
export const TOKEN_AVATAR_IMAGE_ID = 'token-avatar-image';
export const STACKED_AVATARS_OVERFLOW_COUNTER =
  'stacked-avatar-overflow-counter';
export const BROWSER_WEBVIEW_ID = 'browser-webview';

// LoginOptionsSwitch
export const LOGIN_WITH_BIOMETRICS_SWITCH = 'login-with-biometrics-switch';
export const TURN_OFF_REMEMBER_ME_MODAL = 'TurnOffRememberMeConfirm';

// ONBOARDING
export const PROTECT_YOUR_ACCOUNT_SCREEN = 'protect-your-account-screen';
export const MANUAL_BACKUP_STEP_2_CONTINUE_BUTTON =
  'manual-backup-step-2-continue-button';

// Advanced Settings
export const TXN_CONFIRM_SCREEN = 'txn-confirm-screen';
export const TXN_CONFIRM_SEND_BUTTON = 'txn-confirm-send-button';
